//页面初始化
import axios from "./index";

/*页面分页信息查询 包含新闻政策法规*/
export const Ymxxinit = (param) => {
    return axios.httpRequest({
        url: '/crossroad/queryPage',
        method: 'post',
        data: param,
    })
}
/*合同查询*/
export const HtxxSelect = (param) => {
    return axios.httpRequest({
        url: '/crossroad/queryRecord',
        method: 'post',
        data: param,
    })
}

/*合同查询*/
export const zcxwSave = (param) => {
    return axios.httpRequest({
        url: '/crossroad/queryRecord',
        method: 'post',
        data: param,
    })
}

/*政策新闻查询*/
export const getZcxwxxByid = (param) => {
    return axios.httpRequest({
        url: '/crossroad/queryRecord',
        method: 'post',
        data: param,
    })
}
